module.exports = __webpack_public_path__ + "img/flip-camera.da115018.svg";